
@switch (columnId) {
  @case (PosTerminalOrderBy.DeviceSerial) {
    <lib-text-table-column>
      {{ element.posConfig?.deviceSerial }}
    </lib-text-table-column>
  }
  @case (PosTerminalOrderBy.DeviceName) {
    <lib-text-table-column>
      {{ element.posConfig?.deviceName }}
    </lib-text-table-column>
  }
  @case (PosTerminalOrderBy.DeviceManufacturer) {
    <lib-text-table-column>
      {{ element.posConfig?.deviceManufacturer }}
    </lib-text-table-column>
  }
  @case (PosTerminalOrderBy.DeviceModel) {
    <lib-text-table-column>
      {{ element.posConfig?.deviceModel }}
    </lib-text-table-column>
  }
  @case (PosTerminalOrderBy.TID) {
    <lib-text-table-column [link]="'/dashboard/organizations/' + element.merchantId + '/tids/' + element.id">
      {{ element.tid }}
    </lib-text-table-column>
  }
  @case (PosTerminalOrderBy.MID) {
    <lib-text-table-column [link]="'/dashboard/organizations/' + element.merchantId + '/mids/' + element.merchantProcessorId">
      {{ element.mid }}
    </lib-text-table-column>
  }
  @case ('gateway') {
    <lib-text-table-column>
      {{ element.gateway }}
    </lib-text-table-column>
  }
  @case ('processor') {
    <lib-text-table-column>
      {{ element.processor }}
    </lib-text-table-column>
  }
  @case (PosTerminalOrderBy.MerchantName) {
    <lib-text-table-column [link]="'/dashboard/organizations/' + element.merchantId">
      {{ element.merchantName }}
    </lib-text-table-column>
  }
  @case (PosTerminalOrderBy.Location) {
    <lib-text-table-column>
      {{ element.posConfig?.deviceLocation }}
    </lib-text-table-column>
  }
  @case (PosTerminalOrderBy.Status) {
    <button mat-stroked-button
      class="status-button"
      [matMenuTriggerFor]="statusMenu"
      [disabled]="isDeviceBusy()">
      <div class="button-inner">
        <div>
          @if (isDeviceBusy()) {
            <span>{{ getBusyText() }}</span>
          } @else {
            <lib-status-chip
              class="device-statuses"
              [status]="element.posConfig?.status">
            </lib-status-chip>
          }
        </div>
        <div class="button-icon"><i [class]="'fas fa-caret-down fa-lg'"></i></div>
      </div>
    </button>
    <mat-menu #statusMenu="matMenu" xPosition="before">
      @for (deviceStatus of deviceStatuses; track deviceStatus) {
        <button mat-menu-item (click)="onUpdateDeviceStatus(deviceStatus)"
          [ngClass]="{'hide-menu-option': (deviceStatus === element.posConfig?.status) || (deviceStatus === PosTerminalStatusEnum.Reassigned) }">
          <lib-status-chip
            class="device-statuses"
            [status]="deviceStatus">
          </lib-status-chip>
        </button>
      }
    </mat-menu>
  }
  @default {
  }
}
